// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2c5SR","modalFooterButton":"ModalNotes_modalFooterButton__3KKSh"};